module.exports = __webpack_public_path__ + "fonts/Arial Narrow Italic.f813173c.ttf";